import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCourses } from '../api';
import './CoursesGrid.css';

const CoursesGrid = () => {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCourses();
        // Filtramos los que NO son gratis (is_free = false)
        const paidCourses = response.data.filter(c => c.is_free === false);
        setCourses(paidCourses);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="courses-grid-container">
      {courses.map((course) => (
        <Link to={`/courses/${course.id}`} key={course.id} className="course-card-link">
          {/* Asignamos clase dinámica según categoría para el color */}
          <div className={`course-card-paid ${course.category === 'mineria' ? 'border-yellow' : 'border-green'}`}>
            
            <div className="card-badge">
              {course.category === 'mineria' ? 'Career Path' : 'Course'}
            </div>
            
            <h3>{course.title}</h3>
            <p>{course.short_description}</p>
            
            <div className="card-footer">
              <span className="level-icon">
                <i className="fas fa-signal"></i> {course.level || 'Intermedio'}
              </span>
              <span className="duration-icon">
                {course.duration_hours} horas
              </span>
            </div>

          </div>
        </Link>
      ))}
    </div>
  );
};

export default CoursesGrid;